import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as CargobaseLogoIcon } from "assets/images/icons/CargobaseLogo.svg";
import Logo from "assets/images/Cargobase_logo_square_blue.png";
import testIds from "constants/testIds";
import NavContext from "./NavContext";

const NavHeader = function () {
  const { navigationConfig } = useContext(NavContext);

  return (
    <Link
      to="/"
      className="pt-24 position-relative text-decoration-none"
      data-testid={testIds.MENU_LOGO}
    >
      {!navigationConfig.expanded && (
        <div className="d-flex justify-content-center">
          <img id="cbShape" src={Logo} alt="Cargobase shape" style={{ width: "24px" }} />
          {navigationConfig.expanded && (
            <span className="font-circular ml-3 text-white" style={{ fontSize: 18 }}>
              CARGOBASE
            </span>
          )}
        </div>
      )}
      {navigationConfig.expanded && (
        <div className="d-flex justify-content-center" style={{ paddingRight: 5 }}>
          <CargobaseLogoIcon />
        </div>
      )}
    </Link>
  );
};

export default NavHeader;
